import { Button } from "../../components/Button";
import { Section } from "../../components/Section";
import { SectionTitle } from "../../components/SectionTitle";
import { Spacer } from "../../components/Spacer";
import { SubSection } from "../../components/SubSection";
import { LocationSvg } from "../../components/Svg/Icons/Location";
import { FadeUp } from "../../components/Transitions/FadeUp";
import { Activities } from "./Activities";
import { DressCode } from "./DressCode";
import { GiftInfo } from "./GiftInfo";
import { MeetingPoint } from "./MeetingPoint";
import { Transfers } from "./Transfers";

export const Details = () => {
  return (
    <Section className="bg-secondary-light">
      <FadeUp>
        <div>
          <SectionTitle
            title="Detalles del día"
            subtitle="Todo lo que necesitas saber"
            eyeBrow
          />
          <div className="mt-10">
            <div className="mb-8 grid gap-4 md:grid-cols-2 md:gap-2 max-w-220 ml-auto mr-auto">
              <div className="flex flex-col h-full w-full md:m-auto md:max-w-100">
                <div className="text-left pl-4 pb-2 text-primary-text eyebrow-md opacity-80">
                  12:00
                </div>
                <Button
                  bgColor="white"
                  textColor="primary-text"
                  borderColor="primary-text"
                  to={{
                    href: "https://maps.app.goo.gl/5GPrGdwyMne3eWgb7",
                    target: "_blank",
                  }}
                  className="m-auto shadow-md"
                  icon={
                    <LocationSvg
                      width="30px"
                      color="var(--color-primary-text)"
                    />
                  }
                >
                  <div className="flex items-center justify-center text-primary-text">
                    <span className="text-md md:text-lg">
                      Iglesia de Santa Catalina
                    </span>
                  </div>
                </Button>
              </div>

              <div className="flex flex-col h-full w-full md:m-auto  md:max-w-100 ">
                <div className="text-left pl-4 pb-2 text-primary-text eyebrow-md opacity-80">
                  14:00
                </div>
                <Button
                  bgColor="white"
                  textColor="primary-text"
                  borderColor="primary-text"
                  to={{
                    href: "https://maps.app.goo.gl/npCAACgPvihV6wGt5",
                    target: "_blank",
                  }}
                  className="m-auto shadow-md"
                  icon={
                    <LocationSvg
                      width="30px"
                      color="var(--color-primary-text)"
                    />
                  }
                >
                  <div className="flex items-center justify-center text-center text-primary-text ">
                    <span className="text-md md:text-lg ">
                      Hacienda de Orán
                    </span>
                  </div>
                </Button>
              </div>
            </div>

            <Spacer />
            <div className="max-w-220 m-auto">
              <img
                src="/3.png"
                alt="Hacienda"
                className="soft-card w-full m-auto rounded-4xl object-cover p-2"
              />
            </div>
          </div>
        </div>
      </FadeUp>

      <Spacer />

      <SubSection>
        <Activities />
      </SubSection>

      <SubSection>
        <DressCode />
      </SubSection>

      <SubSection>
        <Transfers />
      </SubSection>

      <SubSection>
        <MeetingPoint />
      </SubSection>

      <SubSection>
        <GiftInfo />
      </SubSection>
    </Section>
  );
};
